import {SportstypeSpec} from "../types";


import start from '../../icons/soccer/start'
import endOfRegularPlay from '../../icons/soccer/end-of-regular-play'
import startOvertime from '../../icons/soccer/start-overtime'
import pauseOvertime from '../../icons/soccer/pause-overtime'
import resumeOvertime from '../../icons/soccer/resume-overtime'
import endOfOvertime from '../../icons/soccer/end-of-overtime'
import startShootout from '../../icons/soccer/start-shootout'
import end from '../../icons/soccer/end'
import goal from '../../icons/soccer/goal'
import ownGoal from '../../icons/soccer/own-goal'
import corner from '../../icons/soccer/corner'
import yellowCard from '../../icons/soccer/yellow-card'
import redCard from '../../icons/soccer/red-card'
import yellowRedCard from '../../icons/soccer/yellow-red-card'
import goalOpportunity from '../../icons/soccer/goal-opportunity'
import freeKick from '../../icons/soccer/free-kick'
import penaltyKick from '../../icons/soccer/penalty-kick'
import penaltyKickMissed from '../../icons/soccer/penalty-kick-missed'
import videoReview from '../../icons/soccer/video-review'
import videoReviewFailed from '../../icons/soccer/video-review-failed'
import videoReviewSuccess from '../../icons/soccer/video-review-success'
import substitution from '../../icons/soccer/substitution'
import substituteOut from '../../icons/_shared/substitute-out'
import substituteIn from '../../icons/_shared/substitute-in'
import main from "../../icons/soccer/main";
import pauseHalves from "../../icons/handball/pause-halves";
import resumeHalves from "../../icons/handball/resume-halves";
import { initializeTeamGameScoreboard, scoreChange, scoreChangeOpponent } from "../eventHandlerUtils";


const soccer: SportstypeSpec = {
  id: 'soccer',
  scoreboardType: 'team-game-scoreboard',
  svg: main,
  showScorers: true,
  releaseStage: 'released',
  defaultTiming: {
    _type: "Tik::Model::Options::TimedGameOptions",
    num_regular_phases: 2,
    num_overtime_phases: 2,
    timing_type: "aui",
    regular_phase_length: 45,
    overtime_phase_length: 15
  },
  displayTimeFormat: 'M\'',
  displayPhaseFormat: '',
  displayPhaseOvertimeFormat: 'extra-time',
  events: [
    {
      id: 'start',
      important: false,
      svg: start,
      eventHandler: initializeTeamGameScoreboard
    },
    {
      id: 'pause-halves',
      important: false,
      svg: pauseHalves
    },
    {
      id: 'resume-halves',
      important: false,
      svg: resumeHalves
    },
    {
      id: 'end-of-regular-play',
      important: false,
      svg: endOfRegularPlay
    },
    {
      id: 'start-overtime',
      important: false,
      svg: startOvertime
    },
    {
      id: 'pause-overtime',
      important: false,
      svg: pauseOvertime
    },
    {
      id: 'resume-overtime',
      important: false,
      svg: resumeOvertime
    },
    {
      id: 'end-of-overtime',
      important: false,
      svg: endOfOvertime
    },
    {
      id: 'start-shootout',
      important: false,
      svg: startShootout
    },
    {
      id: 'end',
      important: false,
      svg: end
    },
    {
      id: 'goal',
      important: true,
      svg: goal,
      team: 'any',
      eventHandler: scoreChange(1),
      cancellable: true,
      players: [
        {
          id: 'scorer',
          from: 'selected-team'
        },
        {
          id: 'assist',
          from: 'selected-team'
        }
      ]
    },
    {
      id: 'own-goal',
      important: true,
      svg: ownGoal,
      team: 'any',
      eventHandler: scoreChangeOpponent(1),
      players: [
        {
          id: 'scorer',
          from: 'selected-team'
        }
      ],
      cancellable: true
    },
    {
      id: 'corner',
      important: true,
      svg: corner,
      team: 'any',
      players: []
    },
    {
      id: 'yellow-card',
      important: true,
      svg: yellowCard,
      team: 'any',
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'red-card',
      important: true,
      svg: redCard,
      team: 'any',
      cancellable: true,
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'yellow-red-card',
      important: true,
      svg: yellowRedCard,
      team: 'any',
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'substitution',
      important: true,
      svg: substitution,
      team: "any",
      players: [
        {id: 'out', svg: substituteOut},
        {id: 'in', svg: substituteIn}
      ]
    },
    {
      id: 'goal-opportunity',
      important: true,
      svg: goalOpportunity,
      team: 'any',
      players: [
        {id: 'offender'}
      ]
    },
    {
      id: 'free-kick',
      important: true,
      svg: freeKick,
      team: 'any',
      players: [
        {id: 'shooter'}
      ]
    },
    {
      id: 'penalty-kick',
      important: true,
      svg: penaltyKick,
      cancellable: true,
      team: 'any',
      players: [
        {id: 'shooter'},
        {
          id: 'keeper',
          from: 'other-team'
        }
      ]
    },
    {
      id: 'penalty-kick-missed',
      important: true,
      svg: penaltyKickMissed,
      team: 'any',
      players: [
        {id: 'shooter'},
        {
          from: 'other-team',
          id: 'keeper'
        }
      ]
    },
    {
      id: 'video-review',
      important: false,
      svg: videoReview
    },
    {
      id: 'video-review-failed',
      important: false,
      svg: videoReviewFailed
    },
    {
      id: 'video-review-success',
      important: false,
      svg: videoReviewSuccess
    }
  ],
  legacyEventMap: {
    1: 'end',
    2: 'start',
    90: 'corner',
    100: 'goal',
    101: 'own-goal',
    201: 'yellow-card',
    202: 'red-card',
    203: 'yellow-red-card',
    260: 'goal-opportunity',
    271: 'free-kick',
    272: 'penalty-kick',
    273: 'penalty-kick',
    280: 'penalty-kick-missed',
    285: 'video-review',
    286: 'video-review-failed',
    287: 'video-review-success',
    300: 'substitution'
  }
}

export default soccer
